module.exports = __webpack_public_path__ + "img/new_logologinandtkfull.df23ce62.png";